/**
 * @description version 因为这里边需要变量。所以还是用tsx的方式更好
 */

const render = (version: string) => {
    return `<script>window.version = ${version}</script>`;
};

export default render;
